var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGear = function SvgGear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12.5 10c0-1.417-1.083-2.5-2.5-2.5S7.5 8.583 7.5 10s1.083 2.5 2.5 2.5 2.5-1.083 2.5-2.5m3.5 0c0 .833.417 1.667 1.167 2.083l.333.25-1.667 2.917-.416-.25A2.49 2.49 0 0 0 13 15c-.083 0-.083.083-.167.083-.666.417-1.166 1.167-1.166 2v.417H8.333v-.417c0-.833-.416-1.583-1.166-2-.084 0-.167 0-.25-.083A2.49 2.49 0 0 0 4.5 15l-.333.167L2.5 12.333l.333-.166A2.62 2.62 0 0 0 4 10c0-.833-.417-1.667-1.167-2.083l-.333-.25L4.167 4.75l.416.25c.75.417 1.667.417 2.417 0 .083 0 .083-.083.167-.083.666-.417 1.166-1.167 1.166-2V2.5h3.334v.417c0 .833.416 1.583 1.166 2 .084 0 .084.083.167.083.75.417 1.667.417 2.417 0l.333-.167 1.667 2.917-.334.167C16.417 8.333 16 9.167 16 10"
  })));
};
export default SvgGear;